<template>
  <div class="PrepareSignatureViewer" data-locator="prepare-signature-viewer">
    <template v-if="isDataReady">
      <slot name="header" :containerHeight="containerHeight"></slot>
      <v-row ref="prepareSignatureContainer"
             v-resize="containerHeight"
             class="flex-nowrap PrepareSignatureViewer__container"
             data-locator="prepare-signature-container"
             no-gutters
      >
        <v-col cols="3" class="PrepareSignatureViewer__sidebar">
          <slot name="sidebar"></slot>
        </v-col>
        <v-col class="PrepareSignatureViewer__pages">
          <slot name="pages"></slot>
        </v-col>
        <v-col cols="auto" class="overflow-y-auto">
          <div class="PrepareSignatureViewer__thumbs">
            <slot name="thumbs"></slot>
          </div>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <div class="PrepareSignatureViewer__loader">
        <v-progress-circular indeterminate :size="80" :width="5"></v-progress-circular>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import { ComponentPublicInstance, defineComponent } from 'vue'
import { VRow } from 'vuetify/components'

export default defineComponent({
  name: 'PrepareSignatureViewer',
  props: {
    isDataReady: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    isDataReady: {
      handler (newVal) {
        if (newVal) {
          this.containerHeight()
        }
      },
    },
  },
  created () {
    window.scrollTo()
  },
  methods: {
    async containerHeight () {
      await this.$nextTick()
      const buttonsBar = document.querySelector('.stepper__actionsBar, .v-card-actions')
      const vRowContainer = this.$refs['prepareSignatureContainer'] as ComponentPublicInstance<VRow>

      if (!vRowContainer || !buttonsBar) {
        return
      }

      const totalHeight = window.innerHeight
      const container = vRowContainer.$el as HTMLDivElement
      const offset = container.getBoundingClientRect().y
      container.style.height = `${totalHeight - offset - buttonsBar.scrollHeight}px`
    },
  },
})
</script>

<style scoped lang="scss">
@import "@/scss/border-tokens";

.PrepareSignatureViewer {
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  @include border-radius('border-radius-3');

  &__container {
    border-left: get-border();
    border-right: get-border();
    border-bottom: get-border();
    border-bottom-left-radius: get-radius('border-radius-3');
    border-bottom-right-radius: get-radius('border-radius-3');
    min-height: 0;
  }
  &__pages,
  &__sidebar,
  &__thumbs {
    background-color: #fff;
    display: flex;
    flex-direction: column;
    row-gap: 12px;
  }
  &__sidebar,
  &__pages {
    overflow-y: auto;
  }
  &__sidebar {
    border-right: get-border();
    max-width: 340px;
    min-width: 300px;
  }
  &__pages {
    background-color: rgb(var(--v-theme-surface-secondary));
    min-width: 0;
    padding: 24px 0 !important;
  }
  &__thumbs {
    height: 100%;
    min-width: 100px;
    padding: 12px;
    border-left: get-border();
  }
  &__loader {
    min-height: 400px;
    text-align: center;
  }
}
</style>
